// Zoho SalesIQ live chat (same widget as beyondpulse.com). Shown only to logged-in users.
import { ageInYears } from '@/common/dates'
import { PARENTAL_CONSENT_AGE } from '@/constants/AgeConsts'

const WIDGET_SRC = 'https://salesiq.zoho.com/widget?wc=siqcc6a6c9774660fef37171c166acb20f0ae6a3ab14ded92b337094e2504c8eece'
const SCRIPT_ID = 'zsiqscript'

let ready = false
let currentUser = null
let openWhenReady = false

// Parents log in with an account that lists their players; players under
// PARENTAL_CONSENT_AGE are not identified to Zoho
function canIdentify(user) {
  if (Array.isArray(user.playerDetails)) return true
  const age = ageInYears(user.dob)
  return age !== null && age >= PARENTAL_CONSENT_AGE
}

function identify(siq, user) {
  if (!canIdentify(user)) return
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ')
  if (name) siq.visitor.name(name)
  if (user.email) siq.visitor.email(user.email)
  const info = { App: 'Player web app' }
  if (user.playerId) info['Player ID'] = String(user.playerId)
  if (user.organizationName) info.Organization = user.organizationName
  siq.visitor.info(info)
}

// Brings the widget in line with the current login state
function apply() {
  const siq = window.$zoho.salesiq
  if (currentUser) {
    identify(siq, currentUser)
    siq.floatbutton.visible('show')
    if (openWhenReady) siq.floatwindow.visible('show')
  } else {
    siq.floatwindow.visible('hide')
    siq.floatbutton.visible('hide')
  }
  openWhenReady = false
}

// SalesIQ calls ready() on first load and again after reset()
function onReady() {
  ready = true
  apply()
}

function load() {
  if (document.getElementById(SCRIPT_ID)) return
  window.$zoho = window.$zoho || {}
  window.$zoho.salesiq = { ready: onReady }
  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = WIDGET_SRC
  script.defer = true
  document.body.appendChild(script)
}

export function showSupportChat(user) {
  currentUser = user
  if (ready) apply()
  else load()
}

// Used by the sidebar Support link and the mobile apps' ?support link. Views can
// mount before App.vue sets the user, so the request waits for showSupportChat()
export function openSupportChat() {
  openWhenReady = true
  if (ready) apply()
  else if (currentUser) load()
}

// On logout: reset() clears the visitor and their chats so the next person on
// this browser starts fresh; the widget reloads and onReady() hides it
export function hideSupportChat() {
  currentUser = null
  openWhenReady = false
  if (!ready) return
  ready = false
  window.$zoho.salesiq.reset()
}
